import React from 'react';

import { Create3WayForecastSidebar } from '@futrli/predict/forecast/create-forecast/sidebars/create-3-way-forecast-sidebar';
import { CreatePAndLBudgetSidebar } from '@futrli/predict/forecast/create-forecast/sidebars/create-p-and-l-budget-sidebar';

interface ForecastCreationSidebarsProps {
  isPAndLBudgetOpen: boolean;
  isThreeWayForecastOpen: boolean;
  onPAndLBudgetClose: () => void;
  onThreeWayForecastClose: () => void;
}

export const ForecastCreationSidebars = ({
  isPAndLBudgetOpen,
  isThreeWayForecastOpen,
  onPAndLBudgetClose,
  onThreeWayForecastClose
}: ForecastCreationSidebarsProps) => {
  return (
    <>
      {isPAndLBudgetOpen && <CreatePAndLBudgetSidebar isOpen={isPAndLBudgetOpen} onClose={onPAndLBudgetClose} />}
      {isThreeWayForecastOpen && (
        <Create3WayForecastSidebar isOpen={isThreeWayForecastOpen} onClose={onThreeWayForecastClose} />
      )}
    </>
  );
};
